import { BelgianVatRate } from '../enums/BelgianVatRate';
import { BaseSchema, ModelType } from '~~/app/base/schemas/BaseSchema';

type VatRateRelationships = {};

type VatRateAttributes = {
    title: string;
    rate: number;
    belgiumCocontractorMention: boolean;
    belgiumRenovationMention: boolean;
    franceCocontractorMention: boolean;
    key: BelgianVatRate | null;
};

type VatRateMeta = {
    isRateEditable: boolean;
};

export default class VatRateSchema extends BaseSchema<VatRateAttributes, VatRateMeta, VatRateRelationships> {
    protected type: ModelType = ModelType.VAT_RATES;
}
